export default {
  app: {
    golf: {
      title: 'Baneinformation',
      hasEVChargingPoint: 'EV-ladestation',
      hasCaddieService: 'Caddie-service',
      hasTrolley: 'Trolley',
      hasBuggy: 'Buggy',
      hasClubRental: 'Kølleudlejning',
      hasAcademy: 'Akademi',
      hasMarshal: 'Marshal',
      hasPGACertification: 'PGA-certificering',
      hasTrainingArea: 'Træningsområde',
      hasRestaurant: 'Restaurant',
      hasHotel: 'Hotel',
      hasDogsOnCourse: 'Hunde på banen',
      numberOfHoles: 'Antal huller',
    },
  },
};
